import React, { useState, useEffect } from 'react'
import Pagination from '@mui/material/Pagination';
import { getExotelcallHisotryListByFilters } from './ActionCreator';
import Loader from '../../../presentationals/Loader/Loader.component'
import moment from 'moment';
import Nodataimage from '../../../../images/nodata.png'

const type = "CALL";
const status = "SENT";
const itemsPerPage = 10;

export default function CallLogs() {
    const [loader, setLoader] = useState(false)
    const [filteredData, setfilteredData] = useState([])
    const [totalPages,setTotalPages] =useState(0)
    const [currentPage, setCurrentPage] = useState(0);
    const [callRecordPopup, setcallReocrdPopup] = useState({ show: false, data: {} })
    const [payload, setPayload] = useState({
        startDate: moment(new Date()).format("YYYY-MM-DD"),
        endDate: moment(new Date()).format("YYYY-MM-DD")
    })
    const [tableData, setTableData] = useState([])

    useEffect(() => {
        getExotelcallHisotryListByFiltersFnn(currentPage)
    }, [])

    const applyFilter = () => {
        setCurrentPage(0)
        getExotelcallHisotryListByFiltersFnn(0)
    }

    const handlechange = (e, type) => {
        setPayload((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }

    const getExotelcallHisotryListByFiltersFnn = (page) => {
        const start = payload?.startDate + " 00:00:00";
        const end = payload?.endDate + " 23:59:59";
        setLoader(true)
        getExotelcallHisotryListByFilters(type, status, start, end,page,itemsPerPage, callback => {
            setLoader(false)
            // setCurrentPage(1)
            if (callback?.status == 200 && callback?.message == "success") {
                setTableData(callback?.data?.content)
                setTotalPages(callback?.data?.totalPages)
                // filterFunction(callback.data, 1)
            } else {
                setTableData([])
            }
        })
    }

    const filterFunction = (data, currentPageNo) => {
        const indexOfLastItem = currentPageNo * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentItems = data && data?.length > 0 ? data?.slice(indexOfFirstItem, indexOfLastItem) : [];
        setfilteredData(currentItems)
    }

    const handlePageChange = (event, value) => {
        setCurrentPage(value -1);
        getExotelcallHisotryListByFiltersFnn(value -1)
    };

    const viewcallRecording = (type, data) => {
        setcallReocrdPopup({ show: type, data: data })
    }

    const handleJsonDisposition = (item,type)=>{
        let value = JSON.parse(item)
        console.log(JSON.parse(item))
        return value?.[type]
    }

    return (
        <>
            {
                loader ? <Loader /> : ""
            }
            <div className="container-fluid" style={{ marginTop: '40px' }}>
                <div className="row">
                    <div className="col-sm-2 col-xs-12">
                        <label htmlFor="">Start Date</label>
                        <input type="date" className='form-control' value={payload?.startDate} onChange={(e) => handlechange(e, "startDate")} />
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <label htmlFor="">End Date</label>
                        <input type="date" className='form-control' value={payload?.endDate} onChange={(e) => handlechange(e, "endDate")} />
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <button className='btn btn-primary' style={{ marginTop: '22px', padding: '10px' }} onClick={() => applyFilter()}>Apply Filters</button>
                    </div>

                    <div className="col-xs-12">
                        {
                            tableData && tableData?.length > 0 ?
                                <>
                                    <hr />
                                    <div className='phocket-table-new' style={{ borderRadius: "15px", paddingBottom: "2px", marginTop: "20px", boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 8px 0px" }}>
                                        <div style={{ overflowX: "auto" }}>
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th className='text-center'>User Id</th>
                                                        <th className='text-center'>Name</th>
                                                        <th className='text-center'>Email Id</th>
                                                        <th className='text-center'>Mobile Number</th>
                                                        <th className='text-center'>Agent Id</th>
                                                        <th className='text-center'>Campaign Name</th>
                                                        <th className='text-center'>Lead Name</th>
                                                        {/* <th className='text-center'>Form Status</th>
                                                        <th className='text-center'>Loan Status</th> */}
                                                        <th className='text-center'>Call Duration</th>
                                                        <th className='text-center'>Call Status</th>
                                                        <th className='text-center'>Call Dispostion</th>
                                                        <th className='text-center'>Call Recording</th>
                                                        <th className='text-center' style={{minWidth:'200px'}}>Created At</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData?.map((v, id) => {
                                                            return (
                                                                <tr key={id}>
                                                                    <td className='text-center'>{v?.userId || "-"}</td>
                                                                    <td className='text-center'>{v?.name || "-"}</td>
                                                                    <td className='text-center'>{v?.emailId || "-"}</td>
                                                                    <td className='text-center'>{v?.mobileNumber || "-"}</td>
                                                                    <td className='text-center'>{handleJsonDisposition(v?.completePayload,"agentID") || "-"}</td>
                                                                    <td className='text-center'>{v?.campaignName || "-"}</td>
                                                                    <td className='text-center'>{v?.leadName || "-"}</td>
                                                                    {/* <td className='text-center'>{v?.formStatus || "-"}</td>
                                                                    <td className='text-center'>{v?.loanStatus || "-"}</td> */}
                                                                    <td className='text-center'>{v?.callDuration || "-"}</td>
                                                                    <td className='text-center'>{v?.callStatus || "-"}</td>
                                                                    <td className='text-center'>{handleJsonDisposition(v?.completePayload,"desposition") || "-"}</td>
                                                                    <td className='text-center'>

                                                                        <i className='fa fa-play' style={{ cursor: 'pointer' }} onClick={() => viewcallRecording(true, v)}></i>
                                                                    </td>
                                                                    <td className='text-center'>{moment(v?.creationDate).format("DD-MM-YYYY HH:MM:SS") || "-"}</td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'end', margin: '10px 0' }}>
                                            <Pagination
                                                count={totalPages}
                                                page={currentPage + 1}
                                                onChange={handlePageChange}
                                                color="primary"
                                            />
                                        </div>
                                    </div>
                                </>
                                :
                                <div className='text-center' style={{marginTop:'30px'}}>
                                    <img src={Nodataimage} width={"30%"} />
                                </div>
                        }

                        {
                            callRecordPopup?.show ?
                                <div className='background-blur'>
                                    <div className='popup-main  container-fluid max-width-500px dbl-border ' style={{ padding: '20px', borderRadius: "10px", width: '30%', height: '23.5%', top: '20%' }}>
                                        <i className='fa fa-times-circle' style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: "red" }} onClick={() => viewcallRecording(false, {})}></i>
                                        <div className='text-center'>
                                            Call Recording
                                        </div>

                                        <div style={{ marginTop: '30px', textAlign: 'center' }}>
                                            <audio controls>
                                                <source src={callRecordPopup?.data?.recordingUrl || ""} type="audio/mpeg" />
                                            </audio>
                                        </div>
                                    </div>
                                </div>
                                : ''}
                    </div>
                </div>
            </div>
        </>
    )
}
